import type { app__schema__staff__Add } from '../models/app__schema__staff__Add';
import type { app__schema__staff__Get } from '../models/app__schema__staff__Get';
import type { app__schema__staff__Update } from '../models/app__schema__staff__Update';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export type TDataAddStaffApiV1StaffPost = {
                requestBody: app__schema__staff__Add
            }
export type TDataDeleteStaffApiV1StaffStaffIdDelete = {
                staffId: number
            }
export type TDataUpdateStaffApiV1StaffStaffIdPut = {
                requestBody: app__schema__staff__Update
staffId: number
            }

export class StaffService {

	/**
	 * Get All Staff
	 * Get all staff members
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static getAllStaffApiV1StaffGet(): CancelablePromise<unknown> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/staff',
		});
	}

	/**
	 * Add Staff
	 * Add a staff member
	 * @returns app__schema__registration__Get Successful Response
	 * @throws ApiError
	 */
	public static addStaffApiV1StaffPost(data: TDataAddStaffApiV1StaffPost): CancelablePromise<app__schema__staff__Get> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/staff',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete Staff
	 * Delete a registration by ID
	 * @returns app__schema__registration__Get Successful Response
	 * @throws ApiError
	 */
	public static deleteStaffApiV1StaffStaffIdDelete(data: TDataDeleteStaffApiV1StaffStaffIdDelete): CancelablePromise<app__schema__staff__Get> {
		const {
staffId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/staff/{staff_id}',
			path: {
				staff_id: staffId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Staff
	 * Update a staff member by ID
	 * @returns app__schema__registration__Get Successful Response
	 * @throws ApiError
	 */
	public static updateStaffApiV1StaffStaffIdPut(data: TDataUpdateStaffApiV1StaffStaffIdPut): CancelablePromise<app__schema__staff__Get> {
		const {
requestBody,
staffId,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/staff/{staff_id}',
			path: {
				staff_id: staffId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}